module.exports = __webpack_public_path__ + "media/dragon_win.836af3dd.mp3";